var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgFeaturesHero = function SvgFeaturesHero(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1366,
    height: 1046.37,
    viewBox: "0 0 1366 1046.37",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5dceda72-fcdd-485d-bc17-fee18bd1f0cd",
    x1: -89.81,
    y1: 93,
    x2: 1215.82,
    y2: 819.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#150773"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#5333ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "13f34016-d31e-4d22-8e0a-7783cb2b7d71",
    x1: 1034.6,
    y1: 443.19,
    x2: 1197.85,
    y2: 443.19,
    xlinkHref: "#5dceda72-fcdd-485d-bc17-fee18bd1f0cd"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c949a6b4-f432-491a-84d0-7bff7612021c",
    x1: 1044.8,
    y1: 563.1,
    x2: 1186.26,
    y2: 689.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5333ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#5f43ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#8675f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#a69ff4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#bfbff5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#d1d6f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#dbe4f8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dfe9f8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "22090be7-479b-4915-beb7-a4796ed4548f",
    x1: 1214,
    y1: 560.74,
    x2: 1214,
    y2: 404.71,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cd4d9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#2cd4d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f691fa6a-70bb-4fec-9e37-d29304e585b4",
    x1: 1246.38,
    y1: 540.89,
    x2: 1246.38,
    y2: 366.79,
    xlinkHref: "#22090be7-479b-4915-beb7-a4796ed4548f"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "013781d0-72ad-4c0c-9066-ba0456c5eb65",
    x1: 1241.48,
    y1: 576.4,
    x2: 1241.48,
    y2: 356.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5333ed",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#5333ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5333ed",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b0dddec3-febe-4929-934e-48efff249f23",
    x1: 1205.95,
    y1: 401.43,
    x2: 1205.95,
    y2: 461.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cd4d9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#2cd4d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "769f1a0f-b09f-4154-8db8-83374462fea5",
    x1: 1094.52,
    y1: 644.37,
    x2: 1062.01,
    y2: 703.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5333ed",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "0d92a176-6d79-4986-80a4-f5bb4797af2a",
    x1: 1228.38,
    y1: 680.55,
    x2: 1216.74,
    y2: 681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5333ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "80c413db-3d5d-41fd-bf56-f3673b8ea46c",
    x1: 1198.7,
    y1: 671.14,
    x2: 1200.13,
    y2: 666.68,
    xlinkHref: "#0d92a176-6d79-4986-80a4-f5bb4797af2a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "25777830-828d-406a-bba5-b445bfe290f7",
    x1: 1200.41,
    y1: 686.61,
    x2: 1194.8,
    y2: 694.74,
    xlinkHref: "#0d92a176-6d79-4986-80a4-f5bb4797af2a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ffad456e-e3a9-49c6-a333-6b8baec230d8",
    x1: 9691.87,
    y1: 3958.45,
    x2: 9694.62,
    y2: 3959.75,
    gradientTransform: "matrix(-0.87, -0.49, -0.49, 0.87, 11316.8, 1943.53)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6e7075"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#43414e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "831261c6-e9ea-4232-baa4-07fc78c0c9c1",
    x1: 1084.55,
    y1: 510.82,
    x2: 1134.44,
    y2: 510.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2cd4d9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4d9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "6d9aa1c5-7394-4c61-8a16-1033725466c1",
    x1: 1214.24,
    y1: 680.91,
    x2: 1214.24,
    y2: 412.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe9f8",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#2cd4d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#5333ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#5333ed",
    stopOpacity: 0.96
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5333ed",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#5333ed",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#5333ed",
    stopOpacity: 0.49
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#5333ed",
    stopOpacity: 0.21
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5333ed",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "4ac39643-c342-4ad1-80b6-331bad91b7fb",
    x1: 1200.11,
    y1: 582.49,
    x2: 1292.39,
    y2: 631.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dfe9f8",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eff0ff",
    stopOpacity: 0
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "features-hero") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "cebedbc8-7786-4a0c-a6b9-5c61dc53b322",
    "data-name": "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1366,
    height: 1046.37,
    style: {
      fill: "url(#5dceda72-fcdd-485d-bc17-fee18bd1f0cd)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "d79a567b-61d3-4e15-befd-3a73583d0921",
    "data-name": "figures and interactions"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "1106.78 484.51 959.62 569.47 959.62 451.75 1106.78 366.79 1106.78 484.51",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1034.6,427.49V601.94l163.25,94.25V521.74Zm45,125.39-18.16-10.45v-4.58l18.16,10.45Zm3.08-5.76-24.31-14v-4.58l24.31,14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "908.78 604.66 942.99 624.41 942.99 597.04 908.78 577.29 908.78 604.66",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "937.29 616.92 919.07 627.44 919.07 612.87 937.29 602.35 937.29 616.92",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "894.25 553.28 971.33 597.78 971.33 536.12 894.25 491.61 894.25 553.28",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1034.6 428.15 1197.85 522.4 1197.85 458.23 1034.6 363.98 1034.6 428.15",
    style: {
      fill: "url(#13f34016-d31e-4d22-8e0a-7783cb2b7d71)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1083.4 418.81 1149.04 456.71 1149.04 446.46 1083.4 408.56 1083.4 418.81",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1083.4 440.99 1149.04 478.89 1149.04 474.48 1083.4 436.59 1083.4 440.99",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1053.62 415.1 1178.82 487.38 1178.82 483.07 1053.62 410.79 1053.62 415.1",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1058.36 517.77 1082.67 531.75 1082.67 494 1058.36 480.03 1058.36 517.77",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1043.31 607.03 1187.99 690.54 1187.99 645.91 1043.31 562.4 1043.31 607.03",
    style: {
      fill: "url(#c949a6b4-f432-491a-84d0-7bff7612021c)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1104.07 544.4 1128.38 558.38 1128.38 520.63 1104.07 506.66 1104.07 544.4",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1018.73 513.18 1043.04 527.16 1043.04 522.57 1018.73 508.6 1018.73 513.18",
    style: {
      fill: "#2cd4d9",
      fillOpacity: 0.51,
      stroke: "#2cd4d9",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1046.39 536.11 1064.55 546.56 1064.55 541.98 1046.39 531.52 1046.39 536.11",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1104.07 560.32 1128.38 574.29 1128.38 569.71 1104.07 555.74 1104.07 560.32",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1107.14 569.6 1125.3 580.05 1125.3 575.46 1107.14 565.01 1107.14 569.6",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1149.77 586.47 1174.09 600.45 1174.09 595.86 1149.77 581.89 1149.77 586.47",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1152.85 595.75 1171.01 606.2 1171.01 601.62 1152.85 591.17 1152.85 595.75",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1131.48 594.9 1150.9 606.12 1150.9 579.87 1131.48 568.66 1131.48 594.9",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1208.73 613 1189.31 601.79 1189.31 628.03 1208.73 639.24 1208.73 613",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1102.45 540.81 1121.87 552.02 1121.87 525.78 1102.45 514.57 1102.45 540.81",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1179.7 596.24 1160.28 585.03 1160.28 611.27 1179.7 622.48 1179.7 596.24",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1148.3 525.5 1148.3 518.88 1098.41 490.08 1098.41 496.7 1148.3 525.5",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1131.48 557.57 1150.9 568.78 1150.9 542.54 1131.48 531.33 1131.48 557.57",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1239.63,
    cy: 459.57,
    rx: 2.15,
    ry: 1.24,
    transform: "translate(-63.7 681.38) rotate(-30)",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1239.63,
    cy: 451.18,
    rx: 2.15,
    ry: 1.24,
    transform: "translate(-59.51 680.26) rotate(-30)",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinejoin: "round",
      strokeWidth: 2,
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1214,
    y1: 560.74,
    x2: 1214,
    y2: 404.71,
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#22090be7-479b-4915-beb7-a4796ed4548f)"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1235.65 540.89 1235.65 472.77 1257.11 460.19 1257.11 366.79",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#f691fa6a-70bb-4fec-9e37-d29304e585b4)"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1247.48 576.4 1247.48 392.26 1235.9 380.68 1247.05 369.53 1247.05 356.52",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#013781d0-72ad-4c0c-9066-ba0456c5eb65)"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "1198.78 401.43 1198.78 451.61 1213.63 460.19",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#b0dddec3-febe-4929-934e-48efff249f23)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.24,643l71.36-41.05,163.25,94.25-71.36,41.05Zm116.36-90.11-18.16-10.45v-4.58l18.16,10.45Zm3.08-5.76-24.31-14v-4.58l24.31,14Z",
    style: {
      mixBlendMode: "darken",
      fill: "url(#769f1a0f-b09f-4154-8db8-83374462fea5)"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1081.6,
    y1: 630.99,
    x2: 1088.67,
    y2: 660.5,
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1107,641a5,5,0,0,0-2.29-5.88l-13.19-7.61a5,5,0,0,0-7.32,2.85l-12.71,40.25",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1078.78,638.74l6.26-2.85a4.76,4.76,0,0,1,4.76,0l13.74,7.21s0,1.13,0,1.72a1.75,1.75,0,0,1-.87,1.54l-5.34,3.14a4.76,4.76,0,0,1-4.8,0l-12.88-7.47a1.75,1.75,0,0,1-.88-1.53C1078.78,639.93,1078.78,638.74,1078.78,638.74Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.66,637.2l5.38-3.1a4.76,4.76,0,0,1,4.76,0l12.86,7.43a1.76,1.76,0,0,1,0,3l-5.34,3.14a4.76,4.76,0,0,1-4.8,0l-12.88-7.47A1.76,1.76,0,0,1,1079.66,637.2Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.8,635.9l18.41,9.89s0,1.13,0,1.72a1.75,1.75,0,0,1-.87,1.54l-5.34,3.14a4.76,4.76,0,0,1-4.8,0l-17.55-10.15",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.8,634.1l17.53,10.11a1.76,1.76,0,0,1,0,3l-5.34,3.14a4.76,4.76,0,0,1-4.8,0l-17.55-10.15",
    style: {
      fill: "#5333ed"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1073.69,655.45l6.26-2.85a4.76,4.76,0,0,1,4.76,0l13.74,7.21s0,1.13,0,1.72a1.75,1.75,0,0,1-.87,1.54l-5.34,3.14a4.76,4.76,0,0,1-4.8,0l-12.88-7.47a1.75,1.75,0,0,1-.88-1.53C1073.69,656.64,1073.69,655.45,1073.69,655.45Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.57,653.91l5.38-3.1a4.76,4.76,0,0,1,4.76,0l12.86,7.43a1.76,1.76,0,0,1,0,3l-5.34,3.14a4.76,4.76,0,0,1-4.8,0L1074.57,657A1.76,1.76,0,0,1,1074.57,653.91Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.71,652.61l18.41,9.89s0,1.13,0,1.72a1.75,1.75,0,0,1-.87,1.54l-5.34,3.14a4.76,4.76,0,0,1-4.8,0l-17.55-10.15",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1084.71,650.81l17.53,10.11a1.76,1.76,0,0,1,0,3l-5.34,3.14a4.76,4.76,0,0,1-4.8,0L1074.57,657",
    style: {
      fill: "#5333ed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1093.62,683.4,1107,641a5,5,0,0,0-2.29-5.88l-13.19-7.61a5,5,0,0,0-7.32,2.85l-1.24,3.94",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1103.92,
    y1: 643.85,
    x2: 1110.99,
    y2: 673.36,
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1098.79,
    y1: 666.87,
    x2: 1108.13,
    y2: 661.44,
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1207.81,712.69s-3.92,4.5-4.2,4.9a6.74,6.74,0,0,0-1.29,3.1c0,1.25.09,1.73.72,2.31s2.18.3,2.79-.15a8.72,8.72,0,0,0,2.54-2.43,43.36,43.36,0,0,0,3-6.37Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1208,712.77s-3.52,4.11-4.45,5.54-1.49,3.61-.2,4.48,4.06-1.12,5.21-3.24a58.63,58.63,0,0,0,2.49-5.64Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.61,721.53s.17.46.53.48a1.51,1.51,0,0,1,1.18.64.68.68,0,0,0,.86.1,1.32,1.32,0,0,1-1.29.42,1.65,1.65,0,0,1-1.17-.86Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.24,717.67a2,2,0,0,1,1.33.43,2,2,0,0,1,.86,1.19",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.73,716.8a2,2,0,0,1,1.33.43,2,2,0,0,1,.86,1.19",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.39,715.93a2,2,0,0,1,1.33.43,2,2,0,0,1,.86,1.19",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207,715.12a2,2,0,0,1,1.33.43,2,2,0,0,1,.86,1.19",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1207.57,714.23a2,2,0,0,1,1.33.43,2,2,0,0,1,.86,1.19",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1224.23,705.42s5.74-1.63,6.23-1.71a6.74,6.74,0,0,1,3.35.15c1.14.5,1.53.82,1.79,1.63s-.65,2.1-1.32,2.46a8.72,8.72,0,0,1-3.28,1.26,43.36,43.36,0,0,1-7,0Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.22,705.62s5.22-1.43,6.91-1.66,3.9.2,4.14,1.73-2.74,3.19-5.15,3.33a58.63,58.63,0,0,1-6.17-.15Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.44,704.49s.34.35.21.68a1.51,1.51,0,0,0,.07,1.34.68.68,0,0,1-.28.82,1.32,1.32,0,0,0,.93-1,1.65,1.65,0,0,0-.28-1.42Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.83,705.21a2,2,0,0,0-.18,1.39,2,2,0,0,0,.71,1.28",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1228.83,705.29a2,2,0,0,0-.18,1.39,2,2,0,0,0,.71,1.28",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1227.77,705.52a2,2,0,0,0-.18,1.39,2,2,0,0,0,.71,1.28",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.79,705.69a2,2,0,0,0-.18,1.39,2,2,0,0,0,.71,1.28",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.72,705.85a2,2,0,0,0-.18,1.39,2,2,0,0,0,.71,1.28",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1212.63,669.62s.06,23,14.14,16.68a1.41,1.41,0,0,1,1.66.24c.7.77.64,2.49.18,2.82-7.83,5.67-19.68,4.47-20.51-12.25Z",
    style: {
      fill: "url(#0d92a176-6d79-4986-80a4-f5bb4797af2a)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1227.34,
    cy: 687.6,
    rx: 1.87,
    ry: 1.08,
    transform: "translate(-97.71 214.93) rotate(-9.63)",
    style: {
      fill: "#5333ed",
      stroke: "#5333ed",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1229.81,688.45c-.66-1.15-2.76-1.18-4.76-.11h0c-2.46,1.38-7.47,4.15-11.22,5.86a4.39,4.39,0,0,1-5.93-2.41l-2-5.19-13.14,6.17c-1.68,2.53-1.05,4.84-3.24,7.61-4.86,6.14,13.21,3,13.21,3s14.14,3.77,23.82-8.38a3.12,3.12,0,0,0,.37-2c.14-.07.29-.13.43-.22C1229.38,691.58,1230.49,689.64,1229.81,688.45Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.41,705.45a5.47,5.47,0,0,0-1.86-.56h0s-16.77-1.72-29.28-5.52h0c-3-1.13-5.85-.78-6.72.94-1,1.93,1,4.87,4.31,6.55a10.42,10.42,0,0,0,3.86,1.12h0s18,2.28,30.3,1.69h.36v0a1.62,1.62,0,0,0,1.28-.78C1227.14,707.84,1226.14,706.32,1224.41,705.45Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1230.3,688.29c-1.68-1-3.5-1-4.06,0a1.31,1.31,0,0,0-.15.77h0l-18.46,22.48h0l-.07.08c-.42.72.26,1.89,1.51,2.62s2.35.71,2.87.18h0L1232.14,692h0a1.2,1.2,0,0,0,.2-.24C1232.89,690.83,1232,689.26,1230.3,688.29Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1193,693.46c1.17,2,5,2,8.46,0s5.39-5.3,4.22-7.33l-12.94,6.64A2.54,2.54,0,0,0,1193,693.46Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1205.5 688.09 1204.5 688.38 1204.5 692.02 1205.5 692.02 1205.5 688.09",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1203.35 688.38 1200.83 689.78 1200.83 694.08 1203.35 694.08 1203.35 688.38",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.29,671.69a6.18,6.18,0,0,0-5.85-8.19,13.65,13.65,0,0,0-2.73.62c-3.18,1.17-7.83,3.68-10.7,5a16.19,16.19,0,0,0-5.36,4v0l-.15.2-.09.13c-2.44,3.33-4.18,20.6-.46,24.76,1.65,1.84,6.53.84,9.76-1.72a15.71,15.71,0,0,0,4.52-7.36,7.88,7.88,0,0,0-1.19-1.59,2.1,2.1,0,0,0-1.95-.36c-1.67,1.5-4,4.9-5.36,5.59-2.19,1.13-1.57-3.34-1.57-3.34a4.41,4.41,0,0,0,.43,2.46c1.78,2.09,5.93,2.29,10-.09s6.21-5.95,5.23-8.39a4.08,4.08,0,0,1,.07-1.16C1207.42,679.35,1212.29,671.69,1212.29,671.69Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1199.5,
    cy: 669.62,
    rx: 2.29,
    ry: 3.97,
    transform: "translate(-40.89 1260.05) rotate(-54.63)",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "1.14866071239381px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.47,669.25l0-6.51,6.05,0v8.88C1202.47,673.55,1197.36,671.82,1196.47,669.25Z",
    style: {
      fill: "#eba87c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214,703.76l6.74.92.23-.25a18.08,18.08,0,0,0-6.71-1Z",
    style: {
      fill: "#dfe9f8",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1209.41,709.35l6.81.34-.82.91s-1.7-1-6.5-.62Z",
    style: {
      fill: "#dfe9f8",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1202.62,667.89a.15.15,0,0,0-.13-.11v.58c-.81,1.19-5-.39-6-2.71v-.27a.08.08,0,0,0-.07.07v3.78c.93,2.67,6.23,4.47,6.24,2.43Z",
    style: {
      fill: "url(#80c413db-3d5d-41fd-bf56-f3673b8ea46c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.7,696.51a15.71,15.71,0,0,0,4.52-7.36,7.88,7.88,0,0,0-1.19-1.59,2.1,2.1,0,0,0-1.95-.36c-1.67,1.5-4,4.9-5.36,5.59C1190.53,693.92,1193.47,699.07,1196.7,696.51Z",
    style: {
      fill: "url(#25777830-828d-406a-bba5-b445bfe290f7)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1199.6,
    cy: 688.28,
    rx: 1.08,
    ry: 1.87,
    transform: "translate(-56.07 1267.99) rotate(-54.63)",
    style: {
      fill: "#5333ed",
      stroke: "#5333ed",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1197.91,687.3s2.51.38,2.9-.33a29.26,29.26,0,0,0,.74-3.44V681.8s-1,.1-.94,1.55l-1.2.93Z",
    style: {
      fill: "#eba87c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1205.12,
    cy: 683.41,
    rx: 1.7,
    ry: 0.98,
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1205.12,
    cy: 683.41,
    rx: 1.7,
    ry: 0.98,
    style: {
      fill: "#dfe9f8",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.14,682.64a2.09,2.09,0,0,1-.91.19c-.77,0-1.4-.36-1.4-.81s.63-.81,1.4-.81",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: "0.814737617969513px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1205.12,679.31c-1.68,0-3,.79-3,1.76a2.63,2.63,0,0,0,2,2.62h0a2.67,2.67,0,0,0,2.1,0h0s2-.8,2-2.62C1208.17,680.1,1206.8,679.31,1205.12,679.31Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1205.12,
    cy: 680.91,
    rx: 2.97,
    ry: 1.72,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1205.12,
    cy: 680.91,
    rx: 2.02,
    ry: 1.16,
    style: {
      fill: "#150773"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1203.58,682.59l-2.13-.34L1199,683l.9-1.06a2.06,2.06,0,0,0,.85.24c.84-.16,1-.45,1-.45l-2.18-.7-1.78,1.63a11.84,11.84,0,0,0-.78,2.8,4.15,4.15,0,0,0,3.64,3.85s2.35-.81-.53-3.6l1.46-.72s.46,0,.75-.07a.75.75,0,0,0,.5-.39l-1.16-.13-1.89.52,2.22-1s1.28.42,1.68-.08l-1.85-.58-2.42.62,2.34-1S1203.5,683.22,1203.58,682.59Z",
    style: {
      fill: "#ffc398"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1226.06,689.77a2.8,2.8,0,0,0-.1-1.16l.48-.61,1.84,1.11s0,1.51.77,1.88l0-1.91-.47-1.38s.77.7.88.86c.29.41.34,2.39.73,2.43l.63-.56-.24-2c.44.26,1,.65,1,.65a.47.47,0,0,0,.36,0l-.74-.62a5.48,5.48,0,0,0-2.6-1.77C1227,686.28,1224.12,687.45,1226.06,689.77Z",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196,668.23a4.63,4.63,0,0,0,2.17,3.26c1.79,1.27,3.83,1.46,4.56.43a1.49,1.49,0,0,0,.32-1",
    style: {
      fill: "none",
      stroke: "#5333ed",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1221.46,693.22c-3.19,4.14-8.46,8.09-12.56,7.29a22.39,22.39,0,0,1-3.72-1.8,13.09,13.09,0,0,1-6,1.53,10.29,10.29,0,0,1-2.75-.29,2.9,2.9,0,0,0-1.22,0s6,1.61,9.26,2.17l1.74.34,6.16,1.07a21.14,21.14,0,0,0,2.22-.51l8.73-10.63Z",
    style: {
      fill: "#dfe9f8",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.45,664.85a4.9,4.9,0,0,0,3.88,2.69,6.05,6.05,0,0,0,2.16-.09v-3.79l-6.05,0Z",
    style: {
      fill: "#ffc398",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 1196.23,
    cy: 662.68,
    r: 0.98,
    transform: "translate(385.99 1764.33) rotate(-82.65)",
    style: {
      fill: "#150773"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195.26,659.29a.59.59,0,0,1,0-.18.6.6,0,0,1,.47-.51,5.05,5.05,0,0,1,5.07-4.5l-.2.35a4,4,0,0,1,5.1,4.07,2.91,2.91,0,0,1-3.68,3.91,4,4,0,0,1-4.4-4.57,4,4,0,0,1,.13-.54l-1.52,1,0,.43a.6.6,0,0,1,.24.55.59.59,0,0,1-.06.18,1.08,1.08,0,0,1,.41,1,1.1,1.1,0,0,1-2.18-.28A1.08,1.08,0,0,1,1195.26,659.29Z",
    style: {
      fill: "#150773"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1194.63,661.51a1.41,1.41,0,0,1,1.29-1.53s0,0,.07,0l.17-1.66a4.54,4.54,0,0,1,9,.95l-.39,3.76c-.35,3.37-2.24,3.78-4.48,3.54a4.93,4.93,0,0,1-4.31-3.84A1.39,1.39,0,0,1,1194.63,661.51Z",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1206.65,658.09s0-.05,0-.08a1,1,0,0,0-.88-1.13,1,1,0,0,0-.71.18,3.12,3.12,0,0,0-.72-.89l.21-.27-.45-.48a1.28,1.28,0,0,0-1-1.42,8.26,8.26,0,0,0-4-.15,1.51,1.51,0,0,0-.73.8,1.83,1.83,0,0,0-1.59.32,6.23,6.23,0,0,0-1.89,2.69h0a1.59,1.59,0,0,0,1,2.26.48.48,0,0,0,.26.09c.13,0,.26.05.4.07A4,4,0,0,0,1201,657a5,5,0,0,0,3.34,1.93l.38,0v0a1.28,1.28,0,0,0,.92,1.39.51.51,0,0,0,0,.13.53.53,0,0,0,.06.3.36.36,0,0,0-.13.23.37.37,0,1,0,.73.09.36.36,0,0,0,0,0,.54.54,0,0,0,.41-.45.53.53,0,0,0-.09-.36,1.27,1.27,0,0,0,.12-2.19Z",
    style: {
      fill: "#150773"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M958.93,705.35v-2a2.2,2.2,0,0,0-1.32-2L957,701a2.69,2.69,0,0,0-2.91.49,51.79,51.79,0,0,0-4.46,4.84c-.72.88-1.22,1.57-1.65,2a1.44,1.44,0,0,0,.37,2.21l.52.29a1.44,1.44,0,0,0,1.43,0l8.12-4.69A1,1,0,0,0,958.93,705.35Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M947.76,710a6.94,6.94,0,0,0,1.67.72c.57.08,1.83-.72,1.83-.72l7.67-4.54v1l-7.51,4.48a3.73,3.73,0,0,1-1.18.53,2.06,2.06,0,0,1-1.26-.07l-1.23-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.35,708.74v-2a2.2,2.2,0,0,0-1.32-2l-.61-.26a2.69,2.69,0,0,0-2.91.49,51.79,51.79,0,0,0-4.46,4.84c-.72.88-1.22,1.57-1.65,2a1.44,1.44,0,0,0,.37,2.21l.52.29a1.44,1.44,0,0,0,1.43,0l8.12-4.69A1,1,0,0,0,964.35,708.74Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M949.73,673.59,955.08,705l1-.21a1.87,1.87,0,0,0,1.51-1.91c-.2-5.53-.85-23.66-1-25.79C956.65,677.06,949.73,673.59,949.73,673.59Z",
    style: {
      fill: "#724c3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958,680l2,28.65a2.44,2.44,0,0,0,2.68-2.31c.59-6,2.23-24.17,2.38-26.24C965.07,680,958,680,958,680Z",
    style: {
      fill: "#724c3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964,692.06l.2-2.23c0,.06-5.52-.07-5.52-.07l.17,2.42A7.41,7.41,0,0,0,964,692.06Z",
    style: {
      fill: "#ffc398",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.77,685.68l.46,2.71a15,15,0,0,0,3.05,2.32,12.71,12.71,0,0,0,1.93.94c0-.89-.08-2.65-.08-2.65Z",
    style: {
      fill: "#ffc398",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.08,688s0-.06,0-.09c.83-2.81,6.72-32,0-40.43l-16.75-6.15c-6.81,9.67-.08,40.76-.08,40.76l0,0c.37,2.32,2.49,5,5.7,6.87,4.44,2.56,9.24,2.55,10.73,0a3.17,3.17,0,0,0,.26-.72h0Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 958.41,
    cy: 643.31,
    rx: 5.86,
    ry: 10.14,
    transform: "translate(-77.91 1151.66) rotate(-60)",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "922.47 632.5 924.13 632.37 921.03 630.52 919.85 631.04 920.51 631.37 920.94 631.57 921.33 631.51 921.6 631.88 922.11 631.93 922.27 632.21 922.47 632.5",
    style: {
      fill: "#ffc398"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.53,623.61s-9.31,37.22-28,9l3-2s13.86,20.51,18.74-6.35Z",
    style: {
      fill: "#724c3b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "936.86 633.17 928.72 635.01 922.88 625.28 936.86 633.17",
    style: {
      fill: "#43414e"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "931.54 630.61 928.44 631.31 928.37 631.26 928.12 628.68 931.54 630.61",
    style: {
      fill: "url(#ffad456e-e3a9-49c6-a333-6b8baec230d8)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "929.7 634.26 928.88 634.44 927.89 633.88 928.81 633.76 929.7 634.26",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "930.75 633.97 929.92 634.15 929.03 633.65 929.85 633.47 930.75 633.97",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "931.73 633.7 930.91 633.88 930.02 633.38 930.84 633.19 931.73 633.7",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "929.62 633.34 928.8 633.51 927.91 633.01 928.73 632.83 929.62 633.34",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "930.61 633.06 929.78 633.24 928.9 632.74 929.71 632.56 930.61 633.06",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "929.51 632.44 928.68 632.62 927.8 632.12 928.61 631.94 929.51 632.44",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "928.75 635.28 927.58 622.93 913.92 615.24 915.09 627.59 928.75 635.28",
    style: {
      fill: "#6e7075"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.7,625.22a.36.36,0,0,1-.64.22,1.29,1.29,0,0,1-.38-1.11A.39.39,0,0,1,921,624c-.33-.09-.61.11-.7.55a2.1,2.1,0,0,0,.61,1.8c.46.4.92.24,1-.35a2.09,2.09,0,0,0-.26-1.35A1.19,1.19,0,0,1,921.7,625.22Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "928.75 635.28 936.86 633.42 936.86 633.17 928.72 635.01 928.75 635.28",
    style: {
      fill: "#6e7075"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M919.73,629s0,2.06,0,2.23a.31.31,0,0,0,.43.11c.16-.11.27.2.27.2a.51.51,0,0,0,.39.29.4.4,0,0,0,.42-.28s0,.48.23.64.58,0,.58,0,0,.33.31.37.36-.15.41-.57l.17-1.45a1.54,1.54,0,0,0,.4-1.18l-.82.82-.44,1.82,0-2.18a2,2,0,0,0-.13-1.92l-.49,1.63-.15,1.8-.12-1.8a1.85,1.85,0,0,0,.28-1.79l-.91,1.68-.11,1.9-.12-2.37a1.41,1.41,0,0,0-.15-1.39Z",
    style: {
      fill: "#724c3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.64,628.3l-.07-.1s-10.79-6.12-13.92-8-5.24-1.67-5.24-1.67a6.29,6.29,0,0,0-6,8.34s2.95,9.41,4,11.95c.54,2.31,2.66,4.91,5.82,6.73,3,1.73,6.15,2.31,8.4,1.77a4.67,4.67,0,0,0,1.82-.82l.57-.61c2.73-3,8.44-9.61,8.44-9.61A6.27,6.27,0,0,0,971.64,628.3Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 960.35,
    cy: 625.79,
    rx: 4.29,
    ry: 2.48,
    transform: "translate(-184.99 671.47) rotate(-35.37)",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.71,628.38s-.35,5.43.73,6.9c3.49,4.72,4.58,6.72,5.84,8.48,4.37,6.14-8.13,6.12-8.13,6.12s0,2.89,0,2.83C999.49,655.52,970.71,628.38,970.71,628.38Z",
    style: {
      fill: "#724c3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.23,628.11l.12,6.67c2.4,2.29,6.2,8.92,6.2,8.92h0c.45.93,2.06,1.09,3.6.36s2.45-2.08,2-3a1.14,1.14,0,0,0-.1-.15h0C977.48,628.54,970.23,628.11,970.23,628.11Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M962.19,647.29s3.33.85,3.53.92L971,650l-.61,2.77a12.37,12.37,0,0,1-5.49-.85l-1.81-.22a1.92,1.92,0,0,1-1.55.14l1.24-.75h2.33l-2.63-.69a2.51,2.51,0,0,1-2.29-.72l2.12-.11,2.23.36-2.15-.68a2.31,2.31,0,0,1-2.25-.19l2.3-.6,2.34.43L961.9,648s-1.17.18-1.64-.59Z",
    style: {
      fill: "#724c3b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "955.62 635.95 955.21 635.95 954.54 636.98 955.16 639.05 955.58 639.05 956.74 638.04 955.62 635.95",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "955.21 635.95 954.12 636.98 955.16 639.05 956.33 638.04 955.21 635.95",
    style: {
      fill: "#5333ed"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M967.54,625.9c-4.29,1.8-5.67,7.19-7.85,8.66a7.87,7.87,0,0,1-4.24,1.4s-2.86-1.93-1.84-7.84,5.7-6.85,5.7-6.85",
    style: {
      fill: "none",
      stroke: "#2cd4d9",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.30000000000000004px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.63,625.39l0-7-6.54,0v9.58C957.15,630,962.67,628.17,963.63,625.39Z",
    style: {
      fill: "#5b3427"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.87,628.27c.79,1.11,3,.91,4.93-.46a5,5,0,0,0,2.35-3.52",
    style: {
      fill: "#5b3427"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M946.36,623.05s-1.91,8-3.76,11.77l5.27,1.67a33.8,33.8,0,0,0,2.83-5.57Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 945.23,
    cy: 635.66,
    rx: 1.67,
    ry: 2.77,
    transform: "translate(92.9 1391.34) rotate(-75.48)",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "925.82 634.44 928.8 636.27 931.91 635.47 931.1 634.74 928.75 635.28 924.93 633.17 925.82 634.44",
    style: {
      fill: "#ffc398",
      opacity: 0.5,
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 960.56,
    cy: 705.97,
    rx: 1.05,
    ry: 1.83,
    transform: "translate(-131.11 1184.86) rotate(-60)",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M956.27,708.33l1.75-2a7.15,7.15,0,0,0,1-1.3l3.16,1.83a3.12,3.12,0,0,1-.84,1.23l-2.51,2.06Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.85,704.94l1.75-2a7.15,7.15,0,0,0,1-1.3l3.16,1.83a3.12,3.12,0,0,1-.84,1.23l-2.51,2.06Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 955.15,
    cy: 702.56,
    rx: 1.05,
    ry: 1.83,
    transform: "translate(-130.86 1178.47) rotate(-60)",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M953.17,713.38a6.94,6.94,0,0,0,1.67.72c.57.08,1.83-.72,1.83-.72l7.67-4.54v1l-7.51,4.48a3.73,3.73,0,0,1-1.18.53,2.06,2.06,0,0,1-1.26-.07l-1.23-.54Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.13,621.54h0a4.47,4.47,0,0,0,4.76,2.18,5.73,5.73,0,0,0,1.75-.59l0-3.55-6.54,0Z",
    style: {
      fill: "#724c3b",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.6,619.61a1.28,1.28,0,0,1,.72-1.67h.07l-.29-1.48a4.12,4.12,0,0,1,8.08-1.59l.66,3.37c.59,3-.93,3.87-2.94,4.27a4.47,4.47,0,0,1-4.76-2.18A1.26,1.26,0,0,1,955.6,619.61Z",
    style: {
      fill: "#724c3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M952.88,610.78a.93.93,0,0,1,.65-1.15.92.92,0,0,1,.78.15,2.37,2.37,0,0,1,4-.54,1,1,0,0,1,1,1.7,5,5,0,0,1,3.12.25.69.69,0,0,1,.35.48,2.49,2.49,0,0,1,1.27,2.75,4,4,0,0,0-1.48-2,3,3,0,0,1-1.5,1.14,2.07,2.07,0,0,1-1.43-.1l0,0s-1-.51-1.49,0a1,1,0,0,0,.11,1.43,2.61,2.61,0,0,1,.13.3,1.6,1.6,0,0,1-1.06,2h-.07c.12.12.77.8.55,1.25l-.5.24a1,1,0,0,0-.94-.83.48.48,0,0,0-.28.09,5.18,5.18,0,0,1-.75-1.82,5.27,5.27,0,0,1-.21-2.63,1.1,1.1,0,0,1,.6-.59l-.3-.11a1.47,1.47,0,0,1-1.83-1.44A.93.93,0,0,1,952.88,610.78Z",
    style: {
      fill: "#dfe9f8"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1104,639.48c.3.08.46-.17.68.17a1.76,1.76,0,0,1,.31,1.06,2.28,2.28,0,0,1-.65,1.64,15.86,15.86,0,0,1-5.52,3.48,2.42,2.42,0,0,0-.93.43,5.63,5.63,0,0,1-1.29.84l-.39-1,6.37-4.05,1.46-1.52Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.92,
    cy: 645.94,
    rx: 2.31,
    ry: 1.34,
    transform: "translate(-176.14 634.5) rotate(-30)",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.45,639.79c-.67-1-3,.59-3.76.7a28.42,28.42,0,0,0-5.39,1.13,2.54,2.54,0,0,0-1.68,2.15,2.65,2.65,0,0,0-.06.58,12,12,0,0,1,.2,1.73s0,0,0,0a.67.67,0,0,0,.08.32c.23.4.86.48,1.54.26h0a49.44,49.44,0,0,0,6.11-2.91,13.49,13.49,0,0,0,2.53-2.08C1104.41,641.24,1104.88,640.46,1104.45,639.79Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.63,
    cy: 642.48,
    rx: 1.85,
    ry: 1.07,
    transform: "translate(-174.45 633.89) rotate(-30)",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.76,640a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101,640.39a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.89,640.61a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.71,640.78a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.5,641a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1092.35,632.69c.3.08.46-.17.68.17a1.76,1.76,0,0,1,.31,1.06,2.28,2.28,0,0,1-.65,1.64,15.86,15.86,0,0,1-5.52,3.48,2.42,2.42,0,0,0-.93.43,5.63,5.63,0,0,1-1.29.84l-.39-1,6.37-4.05,1.46-1.52Z",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1084.27,
    cy: 639.15,
    rx: 2.31,
    ry: 1.34,
    transform: "translate(-174.31 627.77) rotate(-30)",
    style: {
      fill: "#0c022f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.81,633c-.67-1-3,.59-3.76.7a28.42,28.42,0,0,0-5.39,1.13A2.54,2.54,0,0,0,1082,637a2.65,2.65,0,0,0-.06.58,12,12,0,0,1,.2,1.73s0,0,0,0a.67.67,0,0,0,.08.32c.23.4.86.48,1.54.26h0a49.44,49.44,0,0,0,6.11-2.91,13.49,13.49,0,0,0,2.53-2.08C1092.77,634.45,1093.24,633.67,1092.81,633Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1083.98,
    cy: 635.69,
    rx: 1.85,
    ry: 1.07,
    transform: "translate(-172.62 627.16) rotate(-30)",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.12,633.24a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1089.36,633.6a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1088.24,633.82a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.07,634a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1085.85,634.22a2.33,2.33,0,0,1,1.51.62",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "1082.66 628.32 1082.3 636.34 1085.67 635.03 1086.38 628.86 1082.66 628.32",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1094.31 635.11 1093.95 643.13 1097.31 641.82 1098.03 635.65 1094.31 635.11",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1086.32,629.43a5.09,5.09,0,0,0-.83-.59l-.26-.13-2.57-.37-.18,3.93a4.79,4.79,0,0,0,1.22,1,4.47,4.47,0,0,0,2.09.63Z",
    style: {
      fill: "#b7835f",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098,636.27a4.14,4.14,0,0,0-.68-.73l-3-.43-.18,3.9a5.15,5.15,0,0,0,.61.42,3.8,3.8,0,0,0,2.79.54Z",
    style: {
      fill: "#b7835f",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1084.55 499.73 1134.44 528.54 1134.44 521.91 1084.55 493.11 1084.55 499.73",
    style: {
      fill: "url(#831261c6-e9ea-4232-baa4-07fc78c0c9c1)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1100.05,500.62l-.88,2.1-.64,3.12.28-3.27a3.38,3.38,0,0,0,0-2.38l-.7,2.12-.54,2.6.16-2.38a2.8,2.8,0,0,0,.51-2.05l-1.2,2-.52,2.34-.09-1.87a1.47,1.47,0,0,0-.11-1.34l-.51,1.41s-.21,2.28-.21,2.5-.11,5.52-.11,5.52-1.8,13.25-2.08,14.61c-.11.53-.37,1.38-.53,2.21a3.71,3.71,0,0,0-.13.48c-.72,3.58-7.71,15.67-7.71,15.67s-.65,10.24,4.24,3.14a51.46,51.46,0,0,0,6.9-15,30.35,30.35,0,0,0,1-5.94l1.08-14.75a12.38,12.38,0,0,0,1-5.45l.39-3A3.18,3.18,0,0,0,1100.05,500.62Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.34,511.39a10.82,10.82,0,0,0,1.79-2.66l-1-.56-.65,1.68Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.4,631.23v-1.11a3.32,3.32,0,0,0-1.91-2.57c-1.47-.85-3.07-.85-3.56,0a1.22,1.22,0,0,0-.1.86h0v1.06h0a3.39,3.39,0,0,0,1.91,2.51c1.47.85,3.07.85,3.56,0a1.08,1.08,0,0,0,.13-.39h0v-.12A1.35,1.35,0,0,0,1087.4,631.23Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.44,636.3h0a3.33,3.33,0,0,0-1.91-2.56c-1.47-.85-3.07-.85-3.56,0a1.16,1.16,0,0,0-.14.7h0v1.14h0a3.31,3.31,0,0,0,1.91,2.58c1.47.85,3.07.85,3.56,0a1.11,1.11,0,0,0,.13-.52h0Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.74,
    cy: 635.11,
    rx: 1.64,
    ry: 2.84,
    transform: "translate(-2.15 1266.49) rotate(-60)",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1084.65,
    cy: 628.86,
    rx: 1.59,
    ry: 2.75,
    transform: "translate(-2.28 1253.77) rotate(-60)",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.76,587.36c-1.15,9.45-4.87,31.29-5.43,48.65l-5.18-1.89s-1.15-43.25-1.17-44.19c0,0-5.16,20.11-4.82,39.83l-4.89-2.28s-.49-35.71,2-49.36a19.66,19.66,0,0,1,1.85-5.46l2.06-4,15,6.2.62,5.18A30.57,30.57,0,0,1,1103.76,587.36Z",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.52,
    cy: 572.62,
    rx: 4.84,
    ry: 8.38,
    transform: "translate(51.85 1235.06) rotate(-60)",
    style: {
      fill: "#5333ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.11,583.19l.88,6.75-.24,1.21a85.41,85.41,0,0,1-1.84-9.76A8.5,8.5,0,0,0,1091.11,583.19Z",
    style: {
      fill: "#5333ed",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.94,516.7s.13,3.28,1,4.29V517.3Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.4,513.76l-.69,2.23.13-2.71a2.51,2.51,0,0,0,0-2.4l-.74,2-.33,2.23v-2.25a2.31,2.31,0,0,0,.49-2.2l-1.27,2-.29,2.36,0-3a1.76,1.76,0,0,0-.07-1.74l-.69,1.81s-.19,3.43-.18,3.64.1,5.52.1,5.52-1.42,14.92-1.79,15.77c-1.13,2.56-6.42,9.14-9.08,12.37a8.35,8.35,0,0,0-2.3,5.36c0,1.76,2.32,2.46,4.4.56,4.29-3.91,7.67-9.59,9.5-13.09a14.37,14.37,0,0,0,1.61-6.18l.48-14.53a12.38,12.38,0,0,0,.84-5.49l.33-1.8a1.92,1.92,0,0,0,.6-1.44Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1109.37,
    cy: 547.74,
    rx: 1.93,
    ry: 3.35,
    transform: "translate(80.33 1234.62) rotate(-60)",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1112.65,549.9c-.3-.26-.24-1.34-.24-1.34s-2.52-.86-2.59-.81-3.2-1.87-3.2-1.87l-1.9,2.17a2.34,2.34,0,0,1-2.93.49l-11.14-6.42h0a2.63,2.63,0,0,0-1.88-.3,6,6,0,0,0-3.62,2.12,3.08,3.08,0,0,0-.59,2l-1.64,12.91c-.67,4.74-3.52,5.4-3.52,7.44,0,2.66,2.77,4.07,6.7,6.34,1.91,1.1,3.68,4.25,7.47,5s7.1-3,10.42-2.18a4.29,4.29,0,0,0,4.38-1.84c1.26-3-1.86-4-2.07-5.71a57,57,0,0,1,0-7.38,8.25,8.25,0,0,1,3.12-6.12l1.44-1.14a5.8,5.8,0,0,0,2.09-1.64l.09-.18A1.45,1.45,0,0,0,1112.65,549.9Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1092.17,
    cy: 537.95,
    rx: 1.93,
    ry: 3.35,
    transform: "translate(247.99 1415.22) rotate(-72.32)",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.31,538.1s.17,1.07.52,1.26a1.45,1.45,0,0,1,.7,1.45l-.05.19a5.8,5.8,0,0,1-1.69,2l-4.57,4.06-2.45,1.13-2.47-.9-.41-3,4.21-7.64s3.47,1.2,3.53,1.14S1095.31,538.1,1095.31,538.1Z",
    style: {
      fill: "#dfe9f8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1087.6,539.41s4.71.56,4.12,5.23l1.44-.15.84-6-5-1.58Z",
    style: {
      fill: "#dfe9f8",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.99,
    cy: 546.49,
    rx: 1.93,
    ry: 3.34,
    transform: "translate(15.91 1123.8) rotate(-54.63)",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.840596079826355px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1101.67,
    cy: 543.77,
    rx: 0.36,
    ry: 0.62,
    transform: "translate(79.91 1225.96) rotate(-60)",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1090.2,532.29s.54-2.72,2.74-3.15",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeMiterlimit: 10,
      strokeWidth: "1.26089411973953px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1097.27,544.68l3-1.73a2.73,2.73,0,0,0,1.37-2.37l-1.08-6.74s-4.95.45-4.95.57S1097.27,544.68,1097.27,544.68Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1098.62 540.01 1098.62 547.71 1093.37 545.73 1093.37 540.72 1098.62 540.01",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1102,533c-2.37-3.33-4.22-2.92-4.22-2.92h0a6.1,6.1,0,0,0-9.08,4.74h0a8.51,8.51,0,0,0,1.63,4.85l.12.16a25.59,25.59,0,0,0,2.3,2.14l.34.28a.86.86,0,0,0,0,.63l.33-.34a2.13,2.13,0,0,0,0,.77l.36-.75a2.13,2.13,0,0,0,0,1l.36-.44a1.43,1.43,0,0,0-.09.61l.65-.72a2.36,2.36,0,0,0,.18.93l.35-.36a2.47,2.47,0,0,0-.12.64,14,14,0,0,1,1.07-1.14,7.13,7.13,0,0,0,3.4-3.84h0c.38-.46.32-2.27.55-2.83l0,0,.31.49a3.09,3.09,0,0,0,.27-1.39l.33.81a3.33,3.33,0,0,0,.46-1.71l.36.75a2.46,2.46,0,0,0,0-1.49l.46.6A2.19,2.19,0,0,0,1102,533Z",
    style: {
      fill: "#2cd4d9"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1098.54,
    cy: 537.52,
    rx: 1.17,
    ry: 0.68,
    transform: "translate(-121.58 621.29) rotate(-30)",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1098.61,540.93a3.66,3.66,0,0,1-1.14-3l2.13-.89.32,1.57Z",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099,536.85c-.63,0-1.14.88-1.14,2s.51,2,1.14,2a2,2,0,0,0,0-4Z",
    style: {
      fill: "#120667"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.62,529.22a5.26,5.26,0,0,1,5.34,1.87,4.34,4.34,0,0,1,1,2.73c.16,1.8.28,4.06.28,4.06",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeMiterlimit: 10,
      strokeWidth: "1.26089411973953px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1099.45,540.33s.47,2.53,1.95,3.3",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinejoin: "round",
      strokeWidth: "0.420298039913178px"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1095.99,
    cy: 546.72,
    rx: 1.66,
    ry: 2.88,
    transform: "translate(74.53 1222.51) rotate(-60)",
    style: {
      fill: "#b7835f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093,545.33a3.72,3.72,0,0,0,1.8,2.73c1.5,1.07,3.22,1.23,3.84.36a1.44,1.44,0,0,0,.24-.9",
    style: {
      fill: "none",
      stroke: "#120667",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      strokeWidth: "0.840596079826355px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1087,571.29a21.37,21.37,0,0,0,2.31-6.84s-1.91,5.34-4.38,6.84C1084.88,571.29,1085.58,572,1087,571.29Z",
    style: {
      fill: "#dfe9f8",
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1101.79,571.36s.67,2.93,2.73,3.74a8.14,8.14,0,0,0-2.62-.11A7.8,7.8,0,0,1,1101.79,571.36Z",
    style: {
      fill: "#dfe9f8",
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1205.12,680.91v-18a1.56,1.56,0,0,1,.65-1.26l.69-.5a2.36,2.36,0,0,0,1-1.92V658a2.82,2.82,0,0,1,1.37-2.42l2-1.19a1.11,1.11,0,0,0,.54-1v-1.39a.37.37,0,0,0-.53-.33l-1.91,1a.12.12,0,0,1-.17-.1V640.46a.05.05,0,0,1,0,0l14.6-8.43V412.83",
    style: {
      fill: "none",
      strokeMiterlimit: 10,
      strokeWidth: 2,
      stroke: "url(#6d9aa1c5-7394-4c61-8a16-1033725466c1)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1191.96 594.9 1305.97 660.04 1305.97 622.29 1191.96 557.15 1191.96 594.9",
    style: {
      fill: "url(#4ac39643-c342-4ad1-80b6-331bad91b7fb)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1191.96 594.9 1216.28 608.87 1216.28 571.12 1191.96 557.15 1191.96 594.9",
    style: {
      fill: "#dfe9f8"
    }
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFeaturesHero);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "dist/static/media/features-hero.e5abbfc0abe8682e85db7688c2043018.svg";